export const hero = {
  heading: 'Become Who You Are.',
  subheading: 'Get The Right Sense of Direction',
  cta: 'Book Your Free Consultation',
  ctaSecondary: 'Call Now',
}

export const intro = {
  heading: 'Choose a Good IFS Coach in California',
  body: [
    "My name is Douglas, and I'm working virtually with professionals across the globe. I guide you in uncovering the parts of yourself that feel at odds, the voice pushing for change, and the one holding back. Instead of forcing a breakthrough, we bring these inner voices into alignment with your deeper values, so progress feels natural rather than exhausting.",
    "With over 20 years of experience supporting people through life's transitions, I offer a space where clarity surfaces, resistance softens, and forward momentum becomes effortless.",
  ],
  cta: 'Work with Douglas',
}

export const philosophy = {
  heading: 'Why Work with a Certified IFS Coach',
  body: [
    "On paper, life looks good: career, relationships, milestones. Yet deep down, there's a gap. A missing sense of meaning, direction, or wholeness.",
    "Transformation doesn't start with a breakdown; it starts with a clear, honest moment. As your IFS therapy coach, I help you explore the inner parts of yourself that feel in conflict and bring them into alignment with your core values.",
  ],
  cta: 'Learn More',
}

export const process = {
  heading: "Let's Work Together",
  subheading: 'And Make Things Right',
  steps: [
    {
      title: 'Discovery',
      body: "We start with a free consultation to explore what's keeping you stuck and what you want most.",
    },
    {
      title: 'Clarity',
      body: 'Together, we map your inner world to uncover the parts with competing priorities and hidden conflicts.',
    },
    {
      title: 'Alignment',
      body: 'Using IFS coaching, we bring those parts into harmony, easing the resistance that drains your energy.',
    },
    {
      title: 'Action',
      body: 'From that grounded place, we create practical steps that move you forward with clarity and confidence.',
    },
  ],
  cta: 'Book Your Free Consultation',
}

export const testimonials = [
  {
    quote: 'Working with Douglas changed everything. His guidance helped align my inner conflicts, creating real clarity and peace in daily life.',
    name: 'Henry Mills',
  },
  {
    quote: 'Douglas guided me through stuck patterns with compassion. I finally feel balanced, purposeful, and more connected to my values.',
    name: 'Neil Cassidy',
  },
  {
    quote: 'His sessions transformed my perspective, helping me find lasting alignment and freedom.',
    name: 'Ben Maslow',
  },
  {
    quote: "With Douglas's guidance and support, I gained clarity and direction.",
    name: 'Nina Wright',
  },
  {
    quote: "Douglas was great. He had both fantastic ideas and a knack for being able to help me pull ideas out of myself that I could have not thought of on my own. If you need a supportive listener, he's your coach.",
    name: 'Phillip',
  },
  {
    quote: "I would definitely recommend Douglas for Coaching! I didn't have clarity on what direction I should take but he asked really great questions that made me come to a conclusion I was happy with it. He's very laid back which allowed me to relax and put me at ease.",
    name: 'Dennelle W',
  },
  {
    quote: "Douglas is an excellent listener, thinker, and coach. His approach is very collaborative and flexible. If something isn't clicking in your work/life, I wholeheartedly recommend letting Douglas give you a hand.",
    name: 'Alex F',
  },
  {
    quote: 'Douglas has the ability to understand and suggest what to do in the immediate situation as well as how that choice impacts a bigger picture. He does so with compassion and care.',
    name: 'David W',
  },
  {
    quote: 'Douglas was very helpful in allowing me to see my own part in my considerable troubles. I am very thankful to have worked with him.',
    name: 'LYH',
  },
  {
    quote: "Douglas is a kind, open listener and a grounded, thoughtful and generous council at times when I have needed one and sometimes when I didn't even know how much I needed one.",
    name: 'Paul G',
  },
  {
    quote: "Douglas is a lifesaver. His experience, perspective and wisdom have been incredibly helpful to me. He helped me unpack the flaws in my decision making, identify where my expectations were unreasonable and unrealistic, and offered me strategies and support to get back on track professionally and personally. I was skeptical when I first sought his help. It turned out to be one of the best decisions I've ever made.",
    name: 'John H',
  },
  {
    quote: 'Douglas is a supportive and intuitive coach who has led me to discover important new insights as I start a new business venture. I would not hesitate to recommend Douglas to anyone that is looking for a great life coach.',
    name: 'Aubrey Stone',
  },
  {
    quote: 'Douglas is a terrific thought partner. He asks powerful questions and facilitates meaningful dialogue that really helps shift my perspective and allows us to have solution oriented sessions.',
    name: 'Noah',
  },
  {
    quote: 'Douglas is a strong coach and a great individual. He is intuitive and is able to cut through to get to the heart of the matter. He helped me to develop a great marketing line and redirected my focus. Very helpful.',
    name: 'Jim McElroy',
  },
  {
    quote: 'Douglas did a great job listening and asking questions that pushed me to reframe my mindset and approach to specific issues. At the end of our session, I was able to put into place some action items to help me with my issue.',
    name: 'Janet',
  },
]

// Slugs shown on homepage blog preview grid (in order)
export const featuredBlogSlugs = [
  'fallow',
  'overthinking',
  'perspective',
  'the-ideal-you',
  'let-it-go',
  'tribal',
]
